var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmarine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 22H39.736C39.349 22 38.964 22.091 38.618 22.264L35.146 24L2.13098 24.01C0.955977 24.01 0.000976562 24.966 0.000976562 26.14C0.000976562 26.739 0.255977 27.314 0.693977 27.712L8.63998 35H6.49998C5.67198 35 4.99998 35.671 4.99998 36.5C4.99998 37.329 5.67198 38 6.49998 38H37.5C43.29 38 48 33.29 48 27.5V24.5C48 23.122 46.879 22 45.5 22ZM33 21.5C33 19.57 31.43 18 29.5 18H23V14C23 12.897 23.897 12 25.001 12C25.554 12 26.001 11.552 26.001 11C26.001 10.448 25.554 10 25.001 10C22.795 10 21 11.794 21 14V18H18.736C17.402 18 16.203 18.741 15.605 19.935L14.569 22.007L33 22.001V21.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmarine);
export default __webpack_public_path__ + "static/media/submarine.d81245fa48f212338c54134dbfadced3.svg";
export { ForwardRef as ReactComponent };